import { t } from 'ember-intl';
import {
  HdsCardContainer,
  HdsStepperList,
  HdsButton,
} from '@hashicorp/design-system-components/components';
import { Typography } from 'core/components';
import { boxPadding } from 'core/modifiers';

const Create = <template>
  <HdsCardContainer
    @level="mid"
    @hasBorder={{true}}
    {{boxPadding "0 lg lg"}}
    data-test-iam-groups-stepper-create
  >
    <Typography @variant="h3" class="hds-font-weight-medium">
      {{t "components.iam.groups.stepper.create-title"}}
    </Typography>

    <HdsStepperList
      @titleTag="h4"
      @ariaLabel={{t "components.iam.groups.stepper.create-title"}}
      as |S|
    >
      <S.Step @status="progress">
        <:title>{{t "components.iam.groups.stepper.step-1.label"}}</:title>
        <:description>{{t
            "components.iam.groups.stepper.step-1.content"
          }}</:description>
        <:content>
          <HdsButton
            @route="cloud.access-control.groups.create"
            @color="primary"
            @text={{t "components.iam.groups.stepper.step-1.cta"}}
            @icon="plus"
            @iconPosition="leading"
            @size="small"
            data-test-iam-groups-stepper-create-cta
          />
        </:content>
      </S.Step>
      <S.Step>
        <:title>{{t "components.iam.groups.stepper.step-2.label"}}</:title>
        <:description>{{t
            "components.iam.groups.stepper.step-2.content"
          }}</:description>
      </S.Step>
      <S.Step>
        <:title>{{t "components.iam.groups.stepper.step-3.label"}}</:title>
        <:description>{{t
            "components.iam.groups.stepper.step-3.content"
          }}</:description>
      </S.Step>
    </HdsStepperList>
  </HdsCardContainer>
</template>;

export default Create;
